import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Close from '@/icons/Close';
import Pencil from '@/icons/Pencil';
import { FAMILY_RENAME_CALLOUT_STORAGE_PREFIX } from '@/data/family-rename-callout';

import './family-rename-callout.css';

interface FamilyRenameCalloutProps {
  userId?: string | null;
  onDismiss?: () => void;
}

function storageKeyForUser(userId?: string | null): string {
  return `${FAMILY_RENAME_CALLOUT_STORAGE_PREFIX}.${userId ?? 'anonymous'}`;
}

const FamilyRenameCallout: React.FC<FamilyRenameCalloutProps> = ({ userId, onDismiss }) => {
  const { t } = useTranslation('screens');
  const { t: tForms } = useTranslation('forms');
  const storageKey = storageKeyForUser(userId);
  const [dismissed, setDismissed] = useState(true);

  useEffect(() => {
    try {
      setDismissed(localStorage.getItem(storageKey) === '1');
    } catch {
      setDismissed(false);
    }
  }, [storageKey]);

  if (dismissed) return null;

  const handleDismiss = () => {
    try {
      localStorage.setItem(storageKey, '1');
    } catch {
      // ignore
    }
    setDismissed(true);
    onDismiss?.();
  };

  return (
    <div className="family-rename-callout" role="note" data-tour="family-rename-callout">
      <div className="family-rename-callout__icon" aria-hidden>
        <Pencil width={16} height={16} />
      </div>
      <div className="family-rename-callout__content">
        <p className="family-rename-callout__title">{t('families.renameCalloutTitle')}</p>
        <p className="family-rename-callout__body">{t('families.renameCalloutBody')}</p>
      </div>
      <div className="family-rename-callout__actions">
        <button type="button" className="btn btn--primary btn--sm" onClick={handleDismiss}>
          {tForms('actions.gotIt')}
        </button>
        <button
          type="button"
          className="family-rename-callout__close"
          onClick={handleDismiss}
          aria-label={tForms('actions.dismiss')}
        >
          <Close width={14} height={14} />
        </button>
      </div>
    </div>
  );
};

export default FamilyRenameCallout;
